<template>
  <div class="serverList">
    <ul>
      <li class="aaa" v-if="maintain"  v-for="item in process" :key="item.index" @click="toRepairDetails(item.id,item.type)">
        <p class="content">{{item.content}}</p>
        <p class="time">上报日期：{{item.submitTime}}</p>
        <div class="borderButton">
          <p class="borderName" v-if="(item.situation.stateCode === '4' || item.situation.stateCode === '5') && !item.isEvaluate " @click.stop="toEvaluate(item.id)">评价</p>
        </div>
        <p class="status red" v-if="item.situation.stateCode === '1'">{{item.situation.stateValue}}</p>
        <p class="status orange" v-if="item.situation.stateCode === '2'">{{item.situation.stateValue}}</p>
        <p class="status orange" v-if="item.situation.stateCode === '3'">{{item.situation.stateValue}}</p>
        <p class="status blue2" v-if="item.situation.stateCode === '4'">{{item.situation.stateValue}}</p>
        <p class="status blue2" v-if="item.situation.stateCode === '5'">{{item.situation.stateValue}}</p>
      </li>
      <li class="bbb" v-if="complaint"  v-for="item in playList" :key="item.index" @click="toRepairDetails(item.id,item.type)">
        <p class="content">{{item.content}}</p>
        <p class="time">上报日期：{{item.submitTime}}</p>
        <p class="status red" v-if="item.situation.stateCode === '1'">{{item.situation.stateValue}}</p>
        <p class="status orange" v-if="item.situation.stateCode === '2'">{{item.situation.stateValue}}</p>
        <p class="status orange" v-if="item.situation.stateCode === '3'">{{item.situation.stateValue}}</p>
        <p class="status blue2" v-if="item.situation.stateCode === '4'">{{item.situation.stateValue}}</p>
        <p class="status blue2" v-if="item.situation.stateCode === '5'">{{item.situation.stateValue}}</p>
      </li>
    </ul>
    <div :class="loadMoreHide ? 'load-more-hide' : 'load-more-normal'" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <span v-show="loadingShow">加载中...</span>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        maintain:true,//维修单显示
        complaint:false,//投诉单显示
        process:[],
        playList:[],
        isClicked:true,
        isClicked2:false,
        busy: false,
        loadMoreHide:false,
        loadingShow:false,
        pageA:0,//维修单
        pageB:0,//投诉单
        pageSize:10,
        isLastPage:false,
        hideContentPage:false
      }
    },
    mounted (){
      // 报修记录
      let vm = this
      if(sessionStorage.getItem('tousu') === '0'){
        vm.isClicked = true
        vm.isClicked2=false
      }else if(sessionStorage.getItem('tousu') === '1'){
        vm.isClicked = false
        vm.isClicked2=true
      }
      vm.toComplain();
    },
    methods:{
      toComplain(flag){//跳转到报修页面
        const _this = this
        _this.pageB = 1
        _this.playList = []
        console.log(_this.pageA,this.pageB)
        sessionStorage.setItem('tousu','0')
        _this.isClicked = true
        _this.isClicked2=false
        _this.postRequest('wo/list',{
          page:_this.pageA,
          size:_this.pageSize,
          type:1
        },function (data) {
          if(flag){
            _this.loadingShow = false
            if(data.list[0].type === '维修单'){
              _this.maintain = true
              _this.complaint = false
            }
            _this.process=_this.process.concat(data.list)
            for(let i=0;i<data.list.length;i++){
              let obj={}
              obj.stateCode=data.list[i].situation.substring(0,1)
              obj.stateValue=data.list[i].situation.substring(2)
              data.list[i].situation=obj
              //console.log(res.data.data.list[i].situation)
            }
            _this.isLastPage = data.isLastPage
            if(_this.isLastPage){
              _this.busy = true;
            }else{
              _this.busy = false;
            }
          }else{
            _this.process=data.list
            for(let i=0;i<data.list.length;i++){
              let obj={}
              obj.stateCode=data.list[i].situation.substring(0,1)
              obj.stateValue=data.list[i].situation.substring(2)
              data.list[i].situation=obj
            }
            _this.busy = false;
          }
        })
      },
      toServerList (flag) {//跳转到投诉页面
        const _this = this
        _this.pageA = 1
        _this.process = []
        sessionStorage.setItem('tousu','1')
        _this.isClicked = false
        _this.isClicked2=true
        _this.postRequest('wo/list',{
          page:_this.pageB,
          size:_this.pageSize,
          type:2
        },function (data) {
          if(flag){
            _this.loadingShow = false
            if(data.list[0].type === '投诉单'){
              _this.maintain = false
              _this.complaint = true
            }
            _this.playList=_this.playList.concat(data.list)
            _this.pageB = 1
            for(let i=0;i<data.list.length;i++){
              let obj={}
              obj.stateCode=data.list[i].situation.substring(0,1)
              obj.stateValue=data.list[i].situation.substring(2)
              data.list[i].situation=obj
            }
            _this.isLastPage = data.isLastPage
            if(_this.isLastPage){
              _this.busy = true;
            }else{
              _this.busy = false;
            }
          }else{
            _this.isLastPage = data.isLastPage
            _this.playList=data.list
            for(let i=0;i<data.list.length;i++){
              let obj={}
              obj.stateCode=data.list[i].situation.substring(0,1)
              obj.stateValue=data.list[i].situation.substring(2)
              data.list[i].situation=obj
            }
            _this.busy = false;
          }
        })
      },
      loadMore () {
        // 多次加载数据
        this.busy = true
        this.loadingShow = true
        if(sessionStorage.getItem('tousu') === '0'){
          this.pageA ++
          this.toComplain(true)
        }else{
          this.pageB ++
          this.toServerList(true)
        }
      },
      toRepairDetails(id,type){//跳转到报修详情页面
        if(type==='投诉单'){
          this.$router.push({
            name:'complainDetails',
            params:{id:id }
          })
        }else if(type==='维修单'){
          this.$router.push({
            name:'repairDetails',
            params:{id:id }
          })
        }
      },
      toEvaluate(id){
        this.$router.push({
          path: "/repairDetails/evaluate",
          name: 'evaluate',
          params: {id: id}
        })
      }
    }
  }
</script>
<style scoped>
  /*状态的判断*/
  .red{
    color: red;
  }
  .orange{
    color: #F69203;
  }
  .blue2{
    color: #0585C8;
  }
  /*新增*/
  .borderButton{
    width: 100%;
    height: 60px;
    margin-bottom: 15px !important;
  }
  .borderName{
    border:1px solid rgba(41,215,156,1);
    border-radius: 29px;
    width: 160px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    float: right;
    color: #0585C8;
  }
  .yellow{
    color: yellow;
  }
  .current{
    background-color: #fff;
    color:#0585C8;
  }
  .serverList{
    width:100%;
    height:100%;
  }

  .serverList ul{
    background-color: #f2f2f2;
    padding-top: 10px;
  }
  .serverList ul li{
    box-sizing: border-box;
    background-color: #fff;
    margin: 40px 26px 0 26px;
    border-radius:10px;
    padding: 34px 23px;
  }
  /*待处理状态*/
  .serverList ul li .status{
    font-size: 28px;
    text-align: right;
    height: 60px;
    line-height: 60px;
    padding-top: 8px;
    box-sizing: border-box;
    padding-right: 20px;
  }
  /*报修内容*/
  .serverList ul li .content{
    font-size: 28px;
    width: 550px;
    color: #333;
    text-align: left;
    margin-left: 30px;
    line-height: 48px;
  }
  /*上报时间*/
  .serverList ul li .time{
    text-align: left;
    font-size: 24px;
    color: #999;
    margin:10px 0 0 30px;
    padding-bottom: 20px;
  }
  .load-more-normal {
    text-align: center;
    line-height: 60px;
  }

  .load-more-hide {
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/xinyuan/BxComplain.vue